// import BASSAPI from './base';
import {config} from '../config/config';
import util from '../util/util';

export default {
  /**
   * @function 写日志
   * @param {string} msgbody 内容
   * @param {string} productName 产品名称
   * @param {string} msgtype 类型
   * @return: void
   */
  async writeLog (msgbody, productName='zbzt-live-sdk', msgtype = 'info') {
    const logMap = {
      debug    : 0,
      info     : 1,
      warnning : 2,
      error    : 3,
      critical : 4
    };
    msgbody = typeof msgbody === 'string' ? msgbody : JSON.stringify(msgbody);
    const args = {
      //日志级别，0：debug,1:info,2:warnning,3:error,4:critical
      'type': logMap[msgtype],
      'msg': `${productName?'['+productName+']--':''} ${msgbody}`
    };
    // await BASSAPI.writeLog(args);
    if (config.weblog === true) {
      if (msgtype === 'info') {
        console.log(`%c [${util.currentTimeString()}]--${args.msg}`, 'color:#60acfc');
      } else {
        console.log(`%c [${util.currentTimeString()}]--${args.msg}`, 'color:#f00');
      }
    }
  }
};
